import { Button } from '@/components/ui/button';
import { Printer } from 'lucide-react';

/**
 * PrintButton - Triggers browser print dialog
 * 
 * @param {string} title - Optional title for print header
 * @param {string} className - Additional CSS classes
 */
const PrintButton = ({ title, className = '', variant = 'outline', size = 'sm' }) => {
  const handlePrint = () => {
    // Set document title for print header
    const originalTitle = document.title;
    if (title) {
      document.title = title;
    }
    
    // Trigger print
    window.print();
    
    // Restore original title
    if (title) {
      document.title = originalTitle;
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handlePrint}
      className={`print-btn no-print ${className}`}
      data-testid="print-button"
    >
      <Printer className="h-4 w-4 mr-2" />
      Print
    </Button>
  );
};

export default PrintButton;
